import React from 'react';
import StepPanel from './StepPanel';
import StepDetails from './StepDetails';
import StepCollection from './StepCollection';
import StepLabQuestions from './StepLabQuestions';
import StepPay from './StepPay';

export default function LabCheckoutStepContent({
  step,
  lab,
  details,
  collection,
  labQuestions,
  payment,
}) {
  if (step === 1) return <StepPanel lab={lab} />;

  if (step === 2) {
    return (
      <StepDetails
        isAuthenticated={details.isAuthenticated}
        patientName={details.patientName}
        patientEmail={details.patientEmail}
        mode={details.detailsMode}
        setMode={details.setDetailsMode}
        email={details.email} setEmail={details.setEmail}
        phone={details.phone} setPhone={details.setPhone}
        dob={details.dob} setDob={details.setDob}
        sex={details.sex} setSex={details.setSex}
        password={details.loginPassword} setPassword={details.setLoginPassword}
        newPassword={details.newPassword} setNewPassword={details.setNewPassword}
        onLogin={details.handleLogin}
        onLogout={details.handleLogout}
        authLoading={details.authLoading}
        authError={details.authError}
      />
    );
  }

  if (step === 3) {
    return (
      <StepCollection
        lab={lab}
        zip={collection.zip} setZip={collection.handleZipChange}
        availResult={collection.availResult}
        availLoading={collection.availLoading}
        onCheckAvailability={collection.handleCheckAvailability}
        selectedMethod={collection.selectedMethod}
        setSelectedMethod={collection.setSelectedMethod}
        address={collection.address}
        setAddress={collection.setAddress}
        addressVerified={collection.addressVerified}
        setAddressVerified={collection.setAddressVerified}
        onStateChange={collection.onStateChange || collection.handleStateChange}
        selectedDrawSite={collection.selectedDrawSite}
        setSelectedDrawSite={collection.setSelectedDrawSite}
      />
    );
  }

  if (step === 4) {
    return (
      <StepLabQuestions
        questions={labQuestions.questions}
        aoeAnswers={labQuestions.aoeAnswers}
        setAoeAnswers={labQuestions.setAoeAnswers}
        missingAoeQuestions={labQuestions.missingAoeQuestions}
        formError={labQuestions.formError}
      />
    );
  }

  if (step === 5) {
    return (
      <StepPay
        lab={lab}
        selectedMethod={collection.selectedMethod}
        total={payment.total}
        subtotal={payment.basePrice}
        couponCode={payment.couponCode}
        setCouponCode={payment.setCouponCode}
        appliedCoupon={payment.appliedCoupon}
        couponError={payment.couponError}
        couponLoading={payment.couponLoading}
        onApplyCoupon={payment.handleApplyCoupon}
        onRemoveCoupon={() => payment.setAppliedCoupon(null)}
        consentHipaa={payment.consentHipaa}
        setConsentHipaa={payment.setConsentHipaa}
        consentTerms={payment.consentTerms}
        setConsentTerms={payment.setConsentTerms}
        consentTele={payment.consentTele}
        setConsentTele={payment.setConsentTele}
        paymentConfig={payment.paymentConfig}
        paymentConfigLoading={payment.paymentConfigLoading}
        savedPaymentMethods={payment.savedPaymentMethods}
        savedPaymentMethodsLoading={payment.savedPaymentMethodsLoading}
        paymentStepRef={payment.paymentStepRef}
        checkoutPolicies={payment.checkoutPolicies}
        checkoutPoliciesLoading={payment.checkoutPoliciesLoading}
        checkoutPoliciesMissing={payment.checkoutPoliciesMissing}
        isSubmitting={payment.isSubmitting}
        formError={payment.formError}
        onPlaceOrder={payment.handlePlaceOrder}
      />
    );
  }

  return null;
}
